import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Template from "./layout";
import NormalizeCss from "./styles/Normalize";
import GloboStyle from "./styles/GlobalStyles";
import TransitionsCSS from "./styles/TransitionsCSS";

import { AuthProvider } from "@/contexts/AuthContext";

function App() {
	return (
		<Router basename={'./'}>
			<AuthProvider>
				<Template />
			</AuthProvider>
			<NormalizeCss />
			<GloboStyle />
			<TransitionsCSS />
		</Router>
	);
}

export default App;
